import React from 'react';
import cn from 'classnames';
import { Link } from 'gatsby';

import logo from '@images/Ein-Sof-Advisors-Logo--Inverse.svg';
import links from '@data/links.json';
import MobileMenu from '@components/MobileMenu/MobileMenu';
import ClientLoginMenu from '@components/ClientLoginMenu/ClientLoginMenu';
import * as css from './Header.module.css';

const Header = ({ ...props }) => (
  <header className={css.header}>
    <div className="l-container flex justify-center">
      <Link to={links.home}>
        <img
          className={css.header__logo}
          src={logo}
          alt="Ein Sof Advisors logo"
        />
      </Link>
    </div>
    <div className={css.navWrapper}>
      <div className={css.navWrapper__inner}>
        <MobileMenu />
        <nav className={css.nav}>
          <Link
            className={css.nav__item}
            to={links.home}
            activeClassName={css.nav__itemActive}
          >
            Home
          </Link>
          <Link
            className={css.nav__item}
            to={links.ourPhilosophy}
            activeClassName={css.nav__itemActive}
          >
            Our Philosophy
          </Link>
          <div
            className={cn([css.nav__item, css.nav__itemHover], {
              [css.nav__itemActive]: props.activeSolutionNav,
            })}
          >
            Solutions
            <div className={css.navFlyout}>
              <Link
                className={css.navFlyout__item}
                to={links.financialPlanning}
                activeClassName={css.navFlyout__itemActive}
              >
                Financial Planning
              </Link>
              <Link
                className={css.navFlyout__item}
                to={links.investmentManagement}
                activeClassName={css.navFlyout__itemActive}
              >
                Investment Management
              </Link>
            </div>
          </div>
          <Link
            className={css.nav__item}
            to={links.education}
            activeClassName={css.nav__itemActive}
          >
            Education
          </Link>
          <Link
            className={css.nav__item}
            to={links.contact}
            activeClassName={css.nav__itemActive}
          >
            Contact
          </Link>
        </nav>
        <div className="flex justify-end">
          <ClientLoginMenu />
        </div>
      </div>
    </div>
  </header>
);

export default Header;
